export function str2uia(str: string): Uint8Array {
    const uia = new Uint8Array(str.length)
    for (let i = 0; i < str.length; i++) {
        uia[i] = str.charCodeAt(i)
    }
    return uia
}

const PUBLIC_KEY_JWK: JsonWebKey = {
    crv: 'P-256',
    ext: true,
    key_ops: ['verify'],
    kty: 'EC',
    x: 'E5rmr-qxtlE8nj1_n9ypycmrI9CM6EOQd_bWYhQys5I',
    y: '9oPL9RWzsY0mQFpTwVL1XT1mqn-CCti-xavPcW-C-ik'
}

const KEY_ALGORITHM = { name: 'ECDSA', namedCurve: 'P-256' } as const
const SIG_ALGORITHM = { name: 'ECDSA', hash: { name: 'SHA-256' } } as const

let cachedKey: CryptoKey | null = null

export async function getPublicKey(): Promise<CryptoKey> {
    if (cachedKey) return cachedKey
    // Cast: TS overloads pick "raw" path because key_ops literal is widened.
    // Runtime accepts 'jwk' fine.
    cachedKey = await (
        window.crypto.subtle.importKey as (
            format: 'jwk',
            keyData: JsonWebKey,
            algorithm: EcKeyImportParams,
            extractable: boolean,
            keyUsages: KeyUsage[]
        ) => Promise<CryptoKey>
    )('jwk', PUBLIC_KEY_JWK, KEY_ALGORITHM, true, ['verify'])
    return cachedKey
}

function toBuffer(u8: Uint8Array): ArrayBuffer {
    // Force dedicated ArrayBuffer (not SharedArrayBuffer) for WebCrypto
    const buf = new ArrayBuffer(u8.byteLength)
    new Uint8Array(buf).set(u8)
    return buf
}

export async function verifySignature(signature: Uint8Array, data: Uint8Array): Promise<boolean> {
    const key = await getPublicKey()
    return window.crypto.subtle.verify(SIG_ALGORITHM, key, toBuffer(signature), toBuffer(data))
}
